export default "__VITE_ASSET__D8lS0WY$__"